// src/data/products.js
export default [
  {
    id: 'lite',
    title: 'FotoMate<sup>&reg;</sup> Lite',
    byline: 'Simple private photo frame',
    images: [
      '/images/product-lite-1.jpg',
      '/images/product-lite-2.jpg',
      '/images/bro-sis2.jpeg',
      '/images/party-upload-1.png',
      '/images/mom-soccer.png'
    ],
    icon: '/images/product-lite-1.jpg',
    externalUrl: 'https://your-shop.myshopify.com/products/fotomate-lite',

    // ✅ Basic features
    features: {
      aiAssistantTime: '1 hour',
      slideshow: true,
      sharing: true,
    },
    description: [
      'FotoMate<sup>&reg;</sup> Lite is the simplest way to get your family photos on a dedicated screen. Plug it in, connect to Wi-Fi, and use the PhotoMate Upload Manager to add pictures and videos—your slideshow appears automatically with no fuss.',
      'Built for privacy and ease, Lite keeps your memories local to the device while giving you effortless playback controls. It’s perfect for grandparents, kitchens, and desks where you want a no-learning-curve frame that “just works.”'
    ],
    about: [
      '7 inch Tablet with Android 12',
      '4 GB RAM (including 2 GB expansion) + 32 GB ROM, supports 1 TB expansion',
      'Quad-core processor, 2 MP front + 5 MP rear cameras',
      '3000 mAh battery, Wi-Fi & Bluetooth'
    ],
    technicalSpecs: [
      { label: 'Brand', value: 'NOVOJOY' },
      { label: 'Model Name', value: 'NQ8black' },
      { label: 'Storage Capacity', value: '32 GB' },
      { label: 'Screen Size', value: '7 Inches' },
      { label: 'Display Resolution', value: '1280 × 800' },
      { label: 'Battery Life', value: 'Up to 8 hours' }
      // …etc
    ],
    additionalInformation: [
      { label: 'ASIN', value: 'B0D4DCZSQF' },
      { label: 'Customer Reviews', value: '3.8 out of 5 stars (45)' },
      { label: 'Best Sellers Rank', value: '#90,041 in Electronics; #1,675 in Computer Tablets' },
      { label: 'Date First Available', value: 'May 17, 2024' }
    ],
    warrantyAndSupport: 'For warranty information about this product, please click here. We offer 1 year of ultimate after-sales service.',
    feedback: 'Would you like to tell us about a lower price?'
  },
  {
    id: 'classic',
    title: 'FotoMate<sup>&reg;</sup> Classic',
    byline: 'Polished slideshow, always simple',
    images: [
      '/images/product-fotomate-1.jpg',
      '/images/mom-livingroom.png',
      '/images/mom-kitchen1.png',
      '/images/large.png',
    ],
    icon: '/images/product-fotomate-2.jpg',
    externalUrl: 'https://your-shop.myshopify.com/products/fotomate-classic',

    // ✅ Basic features
    features: {
      aiAssistantTime: '2 hours',
      slideshow: true,
      sharing: true,
    },
    description: [
      'FotoMate<sup>&reg;</sup> Classic upgrades your everyday frame with a polished slideshow, gentle Grandfather Clock mode, and a built-in Sleep Machine for nighttime ambience. Upload photos and videos through the PhotoMate Upload Manager—your device securely receives them and plays them back beautifully.',
      'Classic is designed for families who want a little more: an always-on companion that’s private by design, responsive, and delightfully simple. It fits kitchens, living rooms, and offices where a premium, distraction-free experience matters.'
    ],
    about: [
      '7 inch Tablet with Android 12',
      '4 GB RAM (including 2 GB expansion) + 32 GB ROM, supports 1 TB expansion',
      'Quad-core processor, 2 MP front + 5 MP rear cameras',
      '3000 mAh battery, Wi-Fi & Bluetooth'
    ],
    technicalSpecs: [
      { label: 'Brand', value: 'NOVOJOY' },
      { label: 'Model Name', value: 'NQ8black' },
      { label: 'Storage Capacity', value: '32 GB' },
      { label: 'Screen Size', value: '7 Inches' },
      { label: 'Display Resolution', value: '1280 × 800' },
      { label: 'Battery Life', value: 'Up to 8 hours' }
      // …etc
    ],
    additionalInformation: [
      { label: 'ASIN', value: 'B0D4DCZSQF' },
      { label: 'Customer Reviews', value: '3.8 out of 5 stars (45)' },
      { label: 'Best Sellers Rank', value: '#90,041 in Electronics; #1,675 in Computer Tablets' },
      { label: 'Date First Available', value: 'May 17, 2024' }
    ],
    warrantyAndSupport: 'For warranty information about this product, please click here. We offer 1 year of ultimate after-sales service.',
    feedback: 'Would you like to tell us about a lower price?'
  },
  {
    id: 'pro',
    title: 'FotoMate<sup>&reg;</sup> Weddings',
    byline: 'Plan, display, celebrate together',
    images: ['/images/man-woman2.jpeg',
      '/images/girl-engaged1.jpeg',
      '/images/man-woman3.jpeg',
      '/images/kitchen-weddings.png',
      '/images/product-weddings-2.jpg',
      '/images/product-weddings-1.jpg',
      '/images/product-weddings-3.jpg',

    ],
    icon: '/images/product-weddings-1.jpg',
    externalUrl: 'https://your-shop.myshopify.com/products/fotomate-pro',

    // ✅ Basic features
    features: {
      aiAssistantTime: '4 hours',
      slideshow: true,
      sharing: true,
    },
    description: [
      '<p>With fotomate<sup>&reg;</sup> <i>weddings</i>, your AI assistant makes planning feel like a conversation, not a chore. You can build your checklist step by step—budgeting, scheduling, and organizing every detail—while your assistant remembers and adapts as plans evolve.</p><p>As you and your fiancé collaborate, every choice becomes a shared memory. When the big day approaches, your checklist also becomes a roadmap you can share with the people who matter most—family, friends, and vendors.</p><p>When the day arrives, fotomate<sup>&reg;</sup> captures the story in real time, transforming guest photos into a joyful, living slideshow.</p>' + 
      '<br><b>Why Fotomate<sup>&reg;</sup>?</b><br>fotomate<sup>&reg;</sup> <i>weddings</i> is designed for couples who want their planning to feel as personal as their vows. Talk to your AI assistant to arrange to-dos, refine timelines, and perfect your checklist with simple conversation.<br><br>Plan side by side with your fiancé, aligning on choices big and small. Then, use your checklist as a communication tool—sharing it with loved ones and vendors so your day runs flawlessly.<br><br>And when the celebration begins, fotomate<sup>&reg;</sup> shifts seamlessly into reception mode, turning every candid photo into part of a live, magical slideshow.'],
    about: [
      '7 inch Tablet with Android 12',
      '4 GB RAM (including 2 GB expansion) + 32 GB ROM, supports 1 TB expansion',
      'Quad-core processor, 2 MP front + 5 MP rear cameras',
      '3000 mAh battery, Wi-Fi & Bluetooth'
    ],
    technicalSpecs: [
      { label: 'Brand', value: 'NOVOJOY' },
      { label: 'Model Name', value: 'NQ8black' },
      { label: 'Storage Capacity', value: '32 GB' },
      { label: 'Screen Size', value: '7 Inches' },
      { label: 'Display Resolution', value: '1280 × 800' },
      { label: 'Battery Life', value: 'Up to 8 hours' }
      // …etc
    ],
    additionalInformation: [
      { label: 'ASIN', value: 'B0D4DCZSQF' },
      { label: 'Customer Reviews', value: '3.8 out of 5 stars (45)' },
      { label: 'Best Sellers Rank', value: '#90,041 in Electronics; #1,675 in Computer Tablets' },
      { label: 'Date First Available', value: 'May 17, 2024' }
    ],
    warrantyAndSupport: 'For warranty information about this product, please click here. We offer 1 year of ultimate after-sales service.',
    feedback: 'Would you like to tell us about a lower price?'
  },
  {
    id: 'baby',
    title: 'Fotomate<sup>&reg;</sup> Baby!',
    byline: 'Sweet moments, gently shared',
    images: [
      '/images/product-baby-1.jpg',
      '/images/product-baby-2.jpg',
      '/images/mom-livingroom.png',
      '/images/dad-kitchen-calendar.jpeg'
    ],
    icon: '/images/product-baby-1.jpg',
    externalUrl: 'https://your-shop.myshopify.com/products/fotomate-pro',

    // ✅ Basic features
    features: {
      aiAssistantTime: '2 hours',
      slideshow: true,
      sharing: true,
    },
    description: [
      '<sup>&reg;</sup> Baby! is the sweetest way to share first smiles, giggles, and milestones with family. Upload moments through the PhotoMate Upload Manager and they’ll appear on your frame in a cozy, ad-free slideshow.',
      'Set the frame to gentle Sleep Machine sounds at night and wake to a fresh rotation of photos in the morning. It’s a private, always-on window into your little one’s world—perfect for nurseries and doting grandparents.'
    ],
    about: [
      '7 inch Tablet with Android 12',
      '4 GB RAM (including 2 GB expansion) + 32 GB ROM, supports 1 TB expansion',
      'Quad-core processor, 2 MP front + 5 MP rear cameras',
      '3000 mAh battery, Wi-Fi & Bluetooth'
    ],
    technicalSpecs: [
      { label: 'Brand', value: 'NOVOJOY' },
      { label: 'Model Name', value: 'NQ8black' },
      { label: 'Storage Capacity', value: '32 GB' },
      { label: 'Screen Size', value: '7 Inches' },
      { label: 'Display Resolution', value: '1280 × 800' },
      { label: 'Battery Life', value: 'Up to 8 hours' }
      // …etc
    ],
    additionalInformation: [
      { label: 'ASIN', value: 'B0D4DCZSQF' },
      { label: 'Customer Reviews', value: '3.8 out of 5 stars (45)' },
      { label: 'Best Sellers Rank', value: '#90,041 in Electronics; #1,675 in Computer Tablets' },
      { label: 'Date First Available', value: 'May 17, 2024' }
    ],
    warrantyAndSupport: 'For warranty information about this product, please click here. We offer 1 year of ultimate after-sales service.',
    feedback: 'Would you like to tell us about a lower price?'
  }
];
